import React from "react";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import { ApolloProvider } from '@apollo/client';
import { ConfigProvider } from 'antd';

import AntForm, { AntFormRailsNested } from "@9troisquarts/ant-form";
import Layout from './components/Layout';
import routes from "../front_devise/routes";
import TranslationProvider from "../../utils/TranslationProvider";
import graphqlClient from "../../utils/graphqlClient";
import flattenRoutes from "../../utils/flattenRoutes";
import moment from 'moment';
import 'moment/locale/fr'
import 'moment/locale/es'

import UserContext from "../../utils/UserContext";
import EnvironmentBanner from "../shared/components/EnvironmentBanner";
import { getLocaleUi, type SupportedLocale } from "../../utils/localeRegistry";
import { configureLocationField } from "../../utils/configureLocationField";
import { configureMarketUi } from "../../utils/marketUi";

const configureAntForm = (locale: string): void => {
  AntForm.configure({
    locale,
    formProps: {
      layout: 'vertical',
    },
  });
};

AntForm.addField('nested', {
  component: AntFormRailsNested,
  showFormItemError: false,
});

type IProps = {
  user: any;
  locale: SupportedLocale;
  environment: string;
  nationalIdRequired?: boolean;
}

const { client } = graphqlClient({ url: '/graphql' });

const App: React.FC<IProps> = props => {
  const {
    environment,
    locale,
    nationalIdRequired = true
  } = props;

  const localeUi = getLocaleUi(locale);

  moment.locale(locale);
  configureAntForm(locale);
  configureLocationField(locale);
  configureMarketUi({ nationalIdRequired });

  return (
    <ConfigProvider locale={localeUi.antd}>
      <UserContext.Provider value={props.user}>
        <BrowserRouter>
          <ApolloProvider client={client}>
            <EnvironmentBanner environment={environment} />
            <Layout user={props.user}>
              <Routes>
                {flattenRoutes(routes).map(route => {
                  const Component = route.component;
                  return (
                    <Route key={route.name} path={route.path} element={<Component />} />
                  )
                })}
              </Routes>
            </Layout>
          </ApolloProvider>
        </BrowserRouter>
      </UserContext.Provider>
    </ConfigProvider>
  )
}

export default TranslationProvider(App);
